var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.componentClass,style:(_vm.componentStyle),attrs:{"data-testid":"skeletonLoader"}},[(!_vm.isLoading)?_vm._t("default"):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }